import type {FormEvent} from 'inferno';

export default function getFilesArrayFromEvent(
    event: FormEvent<HTMLInputElement>|DragEvent): File[] {
    let files: FileList;
    if ((event as DragEvent).dataTransfer?.files?.length) {
        files = (event as DragEvent).dataTransfer.files;
    } else {
        files = (event.target as HTMLInputElement).files;
    }
    // This converts FileList objects to an array. Also handles files being
    // undefined.
    const filesAry: File[] = [...(files || [])];
    return filesAry;
}
